import '../styles/App.css';

import React from 'react';
import chroma from 'chroma-js';

import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Tooltip from '@mui/material/Tooltip';
// import InfoIcon from '@mui/icons-material/Info';  // Import the Info icon
import InfoIcon from './SVGCollection'

import { styled } from '@mui/material/styles';

import Grid from '@mui/material/Grid';
import {GradientBlueGreenRadio} from './SVGCollection'

const StyledRadio = styled(Radio)({
  // Unchecked state - gradient border
  color: 'transparent',
  '& .MuiSvgIcon-root': {
    fontSize: '20px',
    fill: 'url(#gradientBlueGreenRadio)',
  },
  // Checked state - keep the same gradient
  '&.Mui-checked': {
    '& .MuiSvgIcon-root': {
      fill: 'url(#gradientBlueGreenRadio)',
    }
  }
});


export default function InputRadioButtons(props) {
  const handleChange = (item) => {
    props.handleClick(item.target.value, props.name)
  };
  var options = []
  for (var i = 0; i < props.values.length; i++) {
    // this.gradient(percentage).toString()
    options.push(
      
      <FormControlLabel 
        key={props.values[i]} 
        value={props.values[i]} 
        checked={props.startValue === props.values[i] ? true : false} 
        control={<StyledRadio size="small" />} 
        label={
          <span style={{fontFamily: 'Menco, Open Sans, sans-serif', fontWeight: '400', textTransform: 'uppercase', letterSpacing: '0.5px', fontSize: '12px'}}>
            {props.labels[i]}
          </span>}  
        />

      );
  }

  const name = props.name.indexOf('?') !== -1 ? props.name : props.name + ':'


  const infoIcon = props.extraInfo !== '' ? 
    (<span className="info-icon"><InfoIcon tooltipMessage={props.extraInfo}/></span>)
    :
    null


  return (
    <div className='form-item'>
      <svg width={0} height={0}>
        <GradientBlueGreenRadio /> <g fill='url(#gradientBlueGreenRadio)' ></g>
      </svg>

      {/*<FormControl className='form-control' component="fieldset">*/}
        <div className="form-label" >
          {name} {infoIcon}
        
        </div>
        <RadioGroup className="radio-group" onChange={handleChange} row>
          {options}
        </RadioGroup>
      {/*</FormControl>*/}
    </div>
  );
}